import React, { Component } from "react";
import { FiHeadphones, FiMail } from "react-icons/fi";
class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <footer className="footer-area">
          <div className="footer-wrapper">
            <div className="row align-items-end row--0">
              <div className="col-lg-4">
                <div className="footer-left">
                  <div className="inner">
                    <h2>
                      Let's Work <br /> Together
                    </h2>
                    <a className="rn-button-style--2" href="/contact">
                      <span>Contact Us</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="footer-right" data-black-overlay="6">
                  <div className="row">
                    {/* Start Single Address  */}
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                      <div className="rn-address">
                        <div className="icon">
                          <FiHeadphones />
                        </div>
                        <div className="inner ">
                          <h4 className="title">Contact With Phone Number</h4>
                          <p>
                            Adam Ridpath:
                            <a href="tel:90 536 645 31 51">+90 536 645 31 51</a>
                          </p>
                          <p>
                            Yücel Dündar:
                            <a href="tel:+90 532 302 12 77">
                              +90 532 302 12 77
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* End Single Address  */}
                    {/* Start Single Address  */}
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12 mt_mobile--50">
                      <div className="rn-address">
                        <div className="icon">
                          <FiMail />
                        </div>
                        <div className="inner">
                          <h4 className="title">Email Address</h4>
                          <p>
                            <a href="mailto:adam@grandmapleproperties.com">
                              adam@grandmapleproperties.com
                            </a>
                          </p>
                          <p>
                            <a href="mailto:yucel@grandmapleproperties.com">
                              yucel@grandmapleproperties.com
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* End Single Address  */}

                    <div className="col-lg-12">
                      <div className="copyright-text">
                        <p>
                          Copyright © 2025 Grand Maple Properties. All Rights
                          Reserved.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}
export default Footer;
